import { IntegratedPlatform, IntegrationPlatformType } from 'app/integrations/models/integration.model';
import { EMPTY, Observable } from 'rxjs';
import { IntegrationsService } from 'app/integrations/integration.service';
import { environment } from 'environments/environment';

export abstract class PlatformSpecifics {
  abstract allowsImport: boolean;
  abstract allowsUninstall: boolean;
  abstract allowAutoResync: boolean;
  abstract useApiKey: boolean;
  abstract shouldDisplayAccountName: boolean;
  requiresSupportContact?: boolean;
  abstract installationUrl: string;
  customConnectIcon?: string;
  externalPanelUrl?: string;
  isInstalledAutomatically?: boolean;
  public howToLink = environment.DEFAULT_HOW_TO_LINK;

  handleUninstall(platform: IntegratedPlatform): Observable<any> {
    return EMPTY;
  }
}

export class PipeDriveSpecifics extends PlatformSpecifics {
  allowsImport = true;
  allowsUninstall = true;
  allowAutoResync = false;
  useApiKey = false;
  shouldDisplayAccountName = true;
  installationUrl = environment.PIPEDRIVE_INTEGRATION_URL;
  howToLink = environment.PIPEDRIVE_HOW_TO_LINK;

  constructor(private integrationsService: IntegrationsService) {
    super();
  }

  handleUninstall(platform: IntegratedPlatform): Observable<any> {
    return this.integrationsService.deleteIntegration(IntegrationPlatformType.PIPEDRIVE);
  }
}

export class ShopifySpecifics extends PlatformSpecifics {
  allowsImport = true;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = false;
  shouldDisplayAccountName = true;
  installationUrl = environment.SHOPIFY_INTEGRATION_URL;
  howToLink = environment.SHOPIFY_HOW_TO_LINK;
}

export class LiveChatSpecifics extends PlatformSpecifics {
  allowsImport = false;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = false;
  shouldDisplayAccountName = true;
  installationUrl = environment.LIVECHAT_INTEGRATION_URL;
  howToLink = environment.LIVECHAT_HOW_TO_LINK;
}

export class MagentoSpecifics extends PlatformSpecifics {
  allowsImport = false;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = true;
  shouldDisplayAccountName = true;
  installationUrl = environment.MAGENTO_INTEGRATION_URL;
  howToLink = environment.MAGENTO_HOW_TO_LINK;
}

export class ShoperSpecifics extends PlatformSpecifics {
  allowsImport = true;
  allowsUninstall = true;
  allowAutoResync = false;
  useApiKey = false;
  shouldDisplayAccountName = true;
  installationUrl = environment.SHOPER_INTEGRATION_URL;
  howToLink = environment.SHOPER_HOW_TO_LINK;

  handleUninstall(platform: IntegratedPlatform): Observable<any> {
    window.location.href = environment.SHOPER_INTEGRATION_URL;
    return EMPTY;
  }
}

export class ZendeskSpecifics extends PlatformSpecifics {
  allowsImport = true;
  allowsUninstall = true;
  useApiKey = false;
  installationUrl = environment.ZENDESK_INTEGRATION_URL;
  allowAutoResync = true;
  shouldDisplayAccountName = true;
  howToLink = environment.ZENDESK_HOW_TO_LINK;

  constructor(private integrationsService: IntegrationsService) {
    super();
  }

  handleUninstall(platform: IntegratedPlatform): Observable<any> {
    return this.integrationsService.deleteIntegration(IntegrationPlatformType.ZENDESK);
  }
}

export class HubspotSpecifics extends PlatformSpecifics {
  allowsImport = true;
  allowsUninstall = false;
  allowAutoResync = true;
  useApiKey = false;
  shouldDisplayAccountName = true;
  installationUrl = environment.BASE_BACKEND_URL + environment.HUBSPOT_INTEGRATION_PATH;
  howToLink = environment.HUBSPOT_HOW_TO_LINK;
}

export class ZapierSpecifics extends PlatformSpecifics {
  allowsImport = false;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = false;
  shouldDisplayAccountName = false;
  installationUrl = environment.ZAPIER_INTEGRATION_URL;
  customConnectIcon = 'assets/img/channels/arrow-connect.svg';
}

export class TwoWaySpecifics extends PlatformSpecifics {
  allowsImport = false;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = false;
  requiresSupportContact = true;
  shouldDisplayAccountName = false;
  installationUrl = environment.TWO_WAY_INTEGRATION_URL;
  externalPanelUrl = environment.TWO_WAY_INTEGRATION_URL;
}
export class IntegromatSpecifics extends PlatformSpecifics {
  allowsImport = false;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = false;
  shouldDisplayAccountName = false;
  installationUrl = environment.INTEGROMAT_INTEGRATION_URL;
}

export class WebCallSpecifics extends PlatformSpecifics {
  allowsImport = false;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = false;
  requiresSupportContact = true;
  shouldDisplayAccountName = false;
  isInstalledAutomatically = false;
  installationUrl = environment.TWO_WAY_INTEGRATION_URL;
}

export class ClientifySpecifics extends PlatformSpecifics {
  allowsImport = false;
  allowsUninstall = false;
  allowAutoResync = false;
  useApiKey = false;
  requiresSupportContact = false;
  shouldDisplayAccountName = false;
  isInstalledAutomatically = true;
  installationUrl = environment.CLIENTIFY_INTEGRATION_URL;
  customConnectIcon = 'assets/img/channels/arrow-connect.svg';
  howToLink = environment.CLIENTIFY_HOW_TO_LINK;
}
